// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"247":"b2e01742","910":"8573e294"}[chunkId] + ".chunk.js";
};